import GenericCRUD from "../Components/GenericCRUD";
import { airplanes } from "../misc/client";
import { Badge } from "@mantine/core";

export const PlaneScreen = () => (
  <GenericCRUD
    title="Aircraft"
    canCreate={true}
    api={airplanes}
    columns={[
      { key: "plane_public_name", label: "Aircraft Name" },
      { key: "plane_name", label: "Aircraft Registration" },
      { key: "plane_type", label: "ICAO" },
      { key: "status", label: "Status" },
    ]}
    formFields={[
      {
        key: "plane_name",
        label: "Aircraft Registration",
        placeholder: "LV-ABC",
        description: "Max 8 letters/numbers",
        required: true,
        maxLength: 8,
        transform: (value) => {
          const upperValue = value.toUpperCase();
          const regex = /^[A-Z0-9]*$/;
          return regex.test(upperValue) && upperValue.length <= 8
            ? upperValue
            : value.slice(0, -1);
        },
      },
      {
        key: "plane_type",
        label: "ICAO",
        placeholder: "C172",
        transform: (value) => value.toUpperCase(),
      },
      {
        key: "plane_public_name",
        label: "Aircraft Name",
        placeholder: "My Cessna",
        description: "Display name, as you want",
        required: true,
      },
      {
        key: "status",
        label: "Status",
        type: "select",
        options: [
          { value: "active", label: "Active" },
          { value: "disabled", label: "Disabled" },
        ],
        defaultValue: "active",
        required: true,
      },
    ]}
    // Custom validation
    validate={(data) => {
      const errors = {};

      if (!data.plane_name?.trim()) {
        errors.plane_name = "Aircraft registration is required";
      } else if (data.plane_name.length > 8) {
        errors.plane_name = "Aircraft registration must be max 8 characters";
      } else if (!/^[A-Z0-9]+$/.test(data.plane_name)) {
        errors.plane_name =
          "Aircraft registration must contain only letters and numbers";
      }

      if (!data.plane_public_name?.trim()) {
        errors.plane_public_name = "Aircraft name is required";
      }

      return Object.keys(errors).length > 0 ? errors : null;
    }}
    // Format status in table
    formatters={{
      status: (value) => (
        <Badge color={value === "active" ? "green" : "gray"}>
          {value === "active" ? "Active" : "Disabled"}
        </Badge>
      ),
    }}
    modalSize="md"
    submitButtonText="Apstiprināt"
    createButtonText="Add Aircraft"
  />
);
